import { useEffect } from 'react'

import { Layout } from '../../components'
import { PlansPanel } from '../../components/panels'
import { DRAWER_KEYS } from '../../store/constants'

import AuthPage from './AuthPage'

/**
 * @description Renders the PlansPage component. Displays the PlansPage, which includes an AppBar, a Drawer, and a PlansPanel.
 * 
 * @author Maria Eduarda Franke
 * @returns {JSX.Element} The rendered PlansPage component.
 */
const PlansPage = () => {

    useEffect(() => {
        document.title = 'Planos | LCD'
    }, [])

    return (
        <AuthPage>
            <Layout selectedKey={DRAWER_KEYS.PLANS} >
                <PlansPanel />
            </Layout>
        </AuthPage >
    )
}

export default PlansPage